import { Component } from 'react'
import ImageDisplayAndUploadComponent from './ImageDisplayAndUploadComponent'

class ImageDisplayAndUpload extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isUploading: false,
            isDeleting: false,
            errorMessageUpload: false,
            errorMessageDelete: false
        }

        this.onUploadStart = this.onUploadStart.bind(this)
        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)
        this.onDeleteStart = this.onDeleteStart.bind(this)
        this.onResetErrorMessages = this.onResetErrorMessages.bind(this)
    }

    onUploadStart() {
        this.setState({
            isUploading: true
        })
    }

    
    onUploadEndSuccess(data) {
        const { form, field, onChange=false } = this.props

        if(_.has(data, 'id') && _.has(data, 'alt_text') && _.has(data, 'source_url')) {
            const newImageObject = {
                id: data.id,
                format: data.hasOwnProperty('format')  && data.format ? data.format : 'none',
                alt: data.alt_text,
                url: data.source_url,
                position: '',
                positionY: '',
                positionX: ''
            }
            
            form.setFieldValue(field.name, newImageObject)
            form.setErrors({})
            
            this.setState({ 
                errorMessageUpload: false,
                isUploading: false
            })
            if(onChange && !this.state.isUploading) {
                onChange()
            }
        } else {
            this.onUploadEndError('OnUploadEndSuccess: Missing data attributes')
        }
    }

    onUploadEndError(error) {
        this.setState({
            errorMessageUpload: error,
            isUploading: false
        })
    }

    onDeleteStart() {
        const { form, field, onChange=false } = this.props
        
        form.setFieldValue(field.name, '')

        if(onChange && !this.state.isUploading) {
            onChange()
        }
    }

    onResetErrorMessages() {
        this.setState({
            errorMessageUpload: false,
            errorMessageDelete: false
        })
    }

    render() {
        const { field, form, imageType, imageSize = false, textUnderDropzone = '', hideAdditionalText, autoUpload } = this.props
        const { isUploading, errorMessageUpload } = this.state
        const { value } = field
        const hasImage = (_.has(value , 'id') && _.has(value , 'url') && (value.id || value.id==='') && value.url) ? true : false
        const image = hasImage ? field.value : {}
        const errorMessages = [errorMessageUpload]
        const imagePosition = form.values.positionY || form.values.positionY === '0' ? form.values.positionY : form.values.position || form.values.position === '0' ? form.values.position : false
        const imagePositionX = form.values.positionX || form.values.positionX === '0' ? form.values.positionX : false
        const isDisabled = form.isSubmitting || isUploading
        const movieTitle = form.values.movie ? form.values.movie.title ? form.values.movie.title : 'Movie image' : false

        return <ImageDisplayAndUploadComponent
            field={field}
            image={image}
            hasImage={hasImage}
            imageType={imageType ? imageType : false}
            imageSize={imageSize}
            imagePosition={imagePosition}
            hideAdditionalText={hideAdditionalText}
            autoUpload={autoUpload}
            imagePositionX={imagePositionX}
            movieTitle={movieTitle}
            isDisabled={isDisabled}
            isUploading={isUploading}
            textUnderDropzone={textUnderDropzone}
            errorMessages={errorMessages}
            onUploadStart={this.onUploadStart}
            onUploadEndSuccess={this.onUploadEndSuccess}
            onUploadEndError={this.onUploadEndError}
            onDeleteStart={this.onDeleteStart}
            onResetErrorMessages={this.onResetErrorMessages}
        />
    }
}

export default ImageDisplayAndUpload